module.exports = {"id":"dp3_3l3q4","text":"Copyright and licences","instructions":"Which example best represents plagiarism?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.3","questionType":"PickOne","random":true,"options":[{"id":"dp3_3l3q4-a1","text":"Copying work without attribution","score":3.7},{"id":"dp3_3l3q4-a2","text":"Linking to original sources","score":1.3},{"id":"dp3_3l3q4-a3","text":"Quoting with permission","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.3/l3q4.json
// module id = 1163
// module chunks = 41